import RuleEvaluator from './RuleEvaluator';

const neuroRuleEvaluator = new RuleEvaluator();

/**
 * Set the answers for the global rule evaluator
 * @param {Object} answers
 */
const setRuleEvaluatorAnswers = (answers) => {
  const answersArray = [];
  /* eslint-disable-next-line no-unused-vars */
  for (let [key, value] of Object.entries(answers)) {
    answersArray.push(value);
  }
  neuroRuleEvaluator.setAnswers(answersArray);
};

/**
 * Returns global rule evaluator
 * @returns {RuleEvaluator}
 */
const useRuleEvaluator = () => {
  return neuroRuleEvaluator;
};

export { setRuleEvaluatorAnswers, useRuleEvaluator };
